export const ONE_DAY = 24 * 60 * 60 * 1000;

const dateOnly = { year: 'numeric', month: 'numeric', day: 'numeric' };
const yearMonthOnly = { year: 'numeric', month: 'long' };
const defaultDateTimeOptions = { dateStyle: 'short', timeStyle: 'short' }

export const dateToMonth = (date, language) => {
  if (!date) return null

  try {
    return new Intl.DateTimeFormat(languageToFullLanguage(language), yearMonthOnly).format(new Date(date))
    // return new Date(date).toLocaleString('fr-FR', yearMonthOnly)
  } catch (e) {
    return null
  }
}

export const dateToLocaleString = (date, language, options = dateOnly) => {
  if (!date) return null

  try {
    return new Date(date).toLocaleString(languageToFullLanguage(language), options)
  } catch (e) {
    return null
  }
}

export const datetimeToLocaleString = (date, language, options = defaultDateTimeOptions) => {
  if (!date) return null

  try {
    return new Intl.DateTimeFormat(languageToFullLanguage(language), options).format(new Date(date))
  } catch (e) {
    return null
  }
}

const languageToFullLanguage = (language) => {
  switch (language) {
    case 'fr':
      return 'fr-FR'
    case 'de':
      return 'de-DE'
    case 'es':
      return 'es-ES'
    default:
      return 'en-US'
  }

}
